import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Cheveron,
  Locate,
  ProgressStepper,
} from "../../../../../../components/svg/worldSvgs/rmc/Achievements";
import { AppLayout } from "../../../../../../layout/AppLayout";
import { IconOverlay } from "../../../../../../components/world/rmc/IconOverlay";
import { RMCCard } from "../../../../../../components/world/rmc/card";
import Button from "../../../../../../components/world/rmc/Button";
import { RmcContext } from "../../../../../../components/context/RmcContext";
import { useContext } from "react";

const shippingStatuses = ["Pending", "Processing", "Shipped", "Delivered"];

const statusColors = {
  active: "#FFD700",
  inactive: "#1A1F33",
};

const shippingDescriptions = [
  {
    label: "Your Reward Request Is In",
    description:
      "Your redemption request has been received and is currently under review. Kindly await further updates regarding its progress.",
  },
  {
    label: "We’re Working on It",
    description:
      "Your request is being processed. All necessary checks are underway to ensure a smooth and accurate fulfillment.",
  },
  {
    label: "Processing for Shipment",
    description:
      "Your reward has been shipped. Delivery is in progress, and you will be notified upon successful completion.",
  },
  {
    label: "Reward Secured!",
    description:
      "Your reward has been successfully delivered. Thank you for your participation and continued engagement.",
  },
];

const statusIndexMap = {
  pending: 0,
  processing: 1,
  shipped: 2,
  delivered: 3,
};
export const RewardTracking = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const shippingStatus = searchParams.get("status");
  const isProcessing = ["processing", "shipped", "delivered"].includes(
    shippingStatus
  );
  const isShipped = ["shipped", "delivered"].includes(shippingStatus);
  const isDelivered = shippingStatus === "delivered";
  const index = statusIndexMap[shippingStatus];
  const current = shippingDescriptions[index];
  const { slug } = useContext(RmcContext);
  return (
    <AppLayout noNav bg={"!bg-[#111522]"}>
      <div className=" min-h-screen pt-16 pb-20 animate-slide-up">
        <img
          src="/image/world/rmc/house.png"
          alt="house_image"
          className="h-[254px] mb-12 w-full"
        />
        <div className="px-4 flex flex-col justify-center">
          <div className="text-center mb-12">
            <p className="text-2xl text-white font-semibold">House Reward</p>
            <span className="text-xs text-[#FFFFFF80]">
              In Progress - John Doe
            </span>
          </div>
          <div className="grid place-content-center">
            <ProgressStepper
              step2={isProcessing ? statusColors.active : statusColors.inactive}
              step3={isShipped ? statusColors.active : statusColors.inactive}
              step4={isDelivered ? statusColors.active : statusColors.inactive}
            />
          </div>
          <div className="flex items-center gap-2 justify-between mt-5">
            {shippingStatuses.map((x, i) => {
              return (
                <p key={i} className="text-base font-semibold text-[#FFFFFFBF]">
                  {x}
                </p>
              );
            })}
          </div>
          {current && (
            <div className=" my-12 flex items-center flex-col">
              <p className="text-2xl text-white font-semibold mb-4">
                {current.label}
              </p>
              <p className="text-xs text-center text-[#FFFFFF80] leading-tight max-w-[241px]">
                {current.description}
              </p>
            </div>
          )}
          <RMCCard className="flex items-center justify-between gap-3 !py-2.5 !pl-2.5 !pr-7 cursor-pointer mb-5">
            <div className="flex items-center gap-2.5">
              <IconOverlay>
                <Locate />
              </IconOverlay>

              <div>
                <p className="text-base font-semibold text-white mb-1">
                  Do you have any question?
                </p>
                <p className="text-xs font-medium text-[#FFFFFF80] leading-tight ">
                  Let us know on help center now!
                </p>
              </div>
            </div>

            <Cheveron />
          </RMCCard>
          <Button
            onClick={() => navigate(`/worlds/${slug}/achievements`)}
            text="Done"
            className="!py-[18px] !text-lg !font-semibold "
          />
        </div>
      </div>
    </AppLayout>
  );
};
